import { IEnvironment } from 'src/providers/environment/types';
import { environmentService } from 'src/providers/environment/EnvironmentService';
import { TenantDO } from 'src/components/visionx/super-admin/tenants/types';
import { useAppSelector } from 'src/app/hooks';

const useGetTimeToIdle = () => {
  const environment: IEnvironment = environmentService.getEnvironment() as IEnvironment;
  const currentTenant: TenantDO | undefined = useAppSelector(
    (state) => state.organisationsSlice?.currentTenant,
  );

  const NEVER = 'never';

  return currentTenant ? (currentTenant.timeToIdle ?? NEVER) : (environment?.timeToIdle ?? NEVER);
};

export default useGetTimeToIdle;
